var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside-menu",style:({visibility: _vm.Creative.isSelectedCreativeLoaded() ? 'visible' : 'hidden', top: `${_vm.Layout.headerHeight}px`})},[_vm._t("default",function(){return [_vm._v("Aside")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }